import { Component, OnInit } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../environments/environment';
import { Guid } from 'guid-typescript';
import { ActivatedRoute, Router  } from '@angular/router';
import { CampaignService } from '../services/campaign.service';
import { HttpErrorResponse } from '@angular/common/http';
import { RegistrationRoutingService } from '../services/registration-routing.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  campaignCookieName: string="user_campaign";
  branchCheck;
  constructor(
    private readonly oauthService: OAuthService,
    private readonly cookieService: CookieService,
    private readonly campaignService: CampaignService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly registrationRouting: RegistrationRoutingService
  ) { }

  ngOnInit() {
    const queryParams = this.registrationRouting.queryStringParams();

    // If the query params contain utm_source=branches, route to decommission page
    const qs = queryParams?.startsWith('?') ? queryParams.substring(1) : (queryParams || '');
    const params = new URLSearchParams(qs);
    if ((params.get('utm_source') || '').trim().toLowerCase() === 'branches') {
      this.router.navigate(['/page-not-found']);
      return;
    }

    if(queryParams){
      localStorage.setItem('UtmParams', queryParams);
    }
  
    this.azureAdlogin();
  }

  azureAdlogin() {
    let submissionId = '';
    localStorage.removeItem('articleUtm');
    localStorage.removeItem('articleUrlWithtitle');
    localStorage.removeItem('existingUserParam');
    localStorage.removeItem('branchUserOffer');
    if (this.cookieService.get('submissionId')) {
      submissionId = this.cookieService.get('submissionId');
    }
    const submissionCode = Guid.create().toString();
    const loginCallback = () => {
      if (this.oauthService.loginUrl.endsWith('authorize')) {
        this.route.queryParams.subscribe((param) => {
          if (Object.keys(param).length > 0 && param.returnUrl && param.returnUrl.toString().indexOf('/article') > -1) {
            let reqUrl = '';
            let utmUrl = '';
            let scode = Guid.create().toString();
            if (param.returnUrl.toString().indexOf('?') > -1) {
              reqUrl = param.returnUrl.toString().split('?')[0];
              utmUrl = param.returnUrl.toString().split('?')[1];
              localStorage.setItem('articleUrlWithtitle', reqUrl);
              localStorage.setItem('articleUtm', utmUrl);

              let isExisting = utmUrl.split('&')[0].split('=')[1];

              if (isExisting) {
                const params = {
                  articleId: reqUrl.substring(reqUrl.lastIndexOf('/') + 1),
                  utmSource: utmUrl.split('&')[1].split('=')[1],
                  utmMedium: utmUrl.split('&')[2].split('=')[1],
                  utmCampaign: utmUrl.split('&')[3].split('=')[1],
                  isExisting: isExisting
                }
                localStorage.setItem('existingUserParam', JSON.stringify(params));
              }

            }
            this.oauthService.redirectUri = globalThis.location.origin + '/article';
            this.checkBranchUser(submissionId,scode);
            this.checkCampaignB2C(submissionId,scode);
            
          }
          else {
            this.checkBranchUser(submissionId, submissionCode);
            this.checkCampaignB2C(submissionId, submissionCode);
            
          }
        });

      } else {
        setTimeout(() => {
          loginCallback();
        }, 500);
      }

    };
    loginCallback();
  }



  private checkCampaignB2C(submissionId: string, submissionCode: string) {
    let utm_id: string;
    let  campaignLinkedPage: string ='';
    let campaignCookie = this.cookieService.get(this.campaignCookieName);

    if (campaignCookie && campaignCookie !== '') {
      this.campaignService.getActiveCampaign("", campaignCookie).subscribe({
        next: (data: any) => {
          utm_id = data.campaignUtmId;
          campaignLinkedPage = data.campaignLinkedPage;
          const linkedCampaignList: string[] = [
            '/portal/home', '/portal/dashboard', '/portal/account',
            '/portal/offers', '/portal/budget', '/portal/profile', '/portal/faq', '/portal/setting'
          ];


          const isCampaignPageMatch: boolean = linkedCampaignList.includes(campaignLinkedPage);

          if (utm_id !== '' && utm_id !== undefined && campaignLinkedPage !== '' && isCampaignPageMatch) {

            this.oauthService.redirectUri = globalThis.location.origin + data.campaignLinkedPage;
          }
          sessionStorage.setItem('isCampaignUserDcQuote', 'true');

        this.oauthService.initLoginFlow('', {
          submissionId, ccAppUrl: globalThis.location.origin, submissionCode,
          instrumentationKey: environment.appInsights.instrumentationKey,
          utm_id: data.campaignUtmId
        });
        },
        error: () => {}
      });
    }
    else {
      this.oauthService.initLoginFlow('', {
        submissionId, ccAppUrl: globalThis.location.origin, submissionCode,
        instrumentationKey: environment.appInsights.instrumentationKey
      });
    }
  }
  private checkBranchUser(submissionId: string, submissionCode: string){
    
    if (this.cookieService.get('isBranchUserComing')!=='') {
     this.branchCheck = this.cookieService.get('isBranchUserComing');
     if(this.branchCheck!==''){
      
      this.oauthService.redirectUri = globalThis.location.origin + '/portal/dashboard';
     }
     this.oauthService.initLoginFlow('', {
      submissionId, ccAppUrl: globalThis.location.origin, submissionCode,
      instrumentationKey: environment.appInsights.instrumentationKey
    });
    }
    
  }
}
